module.exports = __webpack_public_path__ + "static/media/icon_check.eb3f9b2a.svg";